import Bomb from "./Bomb"
import Entity from "./Entity"
import Explosion from "./Explosion"
import Level from "./Level"
import Match from "./Match"
import { TILE_SIZE, SCALE_FACTOR } from "./config"
import { getAnimation } from "./spritesheet"

export enum PowerUpEnum {
  powerUpBomb = "powerUpBomb",
  powerUpSkates = "powerUpSkates",
  powerUpKick = "powerUpKick",
  powerUpPunch = "powerUpPunch",
  powerUpFire = "powerUpFire"
}

export default class PowerUp extends Entity {
  static POWERUP_SIZE = TILE_SIZE * SCALE_FACTOR
  static SKATES_SPEED_INCREMENT = 1
  static POISON_DURATION = 5000

  type: PowerUpEnum

  constructor(params: { x: number, y: number, level: Level, type: PowerUpEnum }) {
    super({
      x: params.x,
      y: params.y,
      level: params.level,
      speed: 0,
      width: PowerUp.POWERUP_SIZE,
      height: PowerUp.POWERUP_SIZE,
      textures: getAnimation(params.type),
      staticTileCoords: true
    })

    this.type = params.type
    this.animationSpeed = 0.3
    this.play()
  }

  explode() {
    if (this.level instanceof Match && !this.level.started) return
    if (!this.alive) return
    super.explode()
    this.textures = getAnimation("powerUpExplosion")
    this.loop = false
    this.play()
    this.onComplete = () => {
      this.removeFromLevel()
    }
  }

  isBlocking(entityConstructor: typeof Entity.constructor): boolean {
    switch (entityConstructor) {
      case Explosion:
      case Bomb:
        return true
    }

    return false
  }

  toString() {
    return "PowerUp"
  }
}
